//#region src/services/llmService/ILlmServicePublic.ts
const LLM_SERVICE_IDENT = "org.greenhouse.service.LLMService";

//#endregion
export { LLM_SERVICE_IDENT };
//# sourceMappingURL=ILlmServicePublic.js.map